module dg.modals {
    angular.module('dg.modals', []);
}